import Layout from '@/layout';

export default {
  weight: 2,
  path: '/member',
  component: Layout,
  redirect: '/memberList',
  name: 'member',
  meta: { title: '用户', icon: 'el-icon-s-finance' },
  children: [
    {
      path: 'memberList',
      name: 'memberList',
      component: () => import('@/views/member/memberList'),
      meta: { title: '用户管理', icon: 'el-icon-s-data' },
    },
    {
      path: 'memberDetails',
      name: 'memberDetails',
      component: () => import('@/views/member/memberDetails'),
      meta: { title: '用户详情', icon: 'el-icon-s-data', activeMenu: '/member/memberList' },
      hidden: true,
    },
    {
      path: 'opticalResultList',
      name: 'opticalResultList',
      component: () => import('@/views/member/opticalResultList'),
      meta: { title: '镜主管理', icon: 'el-icon-s-data' },
    },
    {
      path: 'weComMemberList',
      name: 'weComMemberList',
      component: () => import('@/views/setting/weComMemberList'),
      meta: { title: '企微成员', icon: 'el-icon-user-solid' },
    },
    {
      path: 'opticalResultDetails',
      name: 'opticalResultDetails',
      component: () => import('@/views/member/opticalResultDetails'),
      meta: { title: '验光详情', icon: 'el-icon-s-data', activeMenu: '/opticalResult/memberList' },
      hidden: true,
    },
  ],
};
